import { isString } from '@/src/helpers';
import { useSelectedTokens } from '@/src/hooks';
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { AccountOffer, Amount } from 'xrpl';
import { TradingFormValues } from '../../../trading.types';

/**
 * Custom hook to understand if there are offers for the selected pair
 * @param offers AccountOffer[]
 * @returns boolean
 */
export const useHasOffersForPair = (offers: AccountOffer[]) => {
  const { watch } = useFormContext<TradingFormValues>();
  const { baseTokenId, quoteTokenId } = watch();
  const [baseToken, quoteToken] = useSelectedTokens(baseTokenId, quoteTokenId);

  return useMemo(() => {
    if (!baseToken || !quoteToken || !offers?.length) return false;

    const matchesPair = (gets: string, pays: string) =>
      (gets === baseToken.code && pays === quoteToken.code) ||
      (gets === quoteToken.code && pays === baseToken.code);

    const getCurrency = (amt: Amount) => (isString(amt) ? 'XRP' : amt.currency);

    return offers.some((offer) =>
      matchesPair(getCurrency(offer.taker_gets), getCurrency(offer.taker_pays))
    );
  }, [offers, baseToken, quoteToken]);
};
